import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { usePqrHeadInfo } from './hook';
import { PqrHeadInfoProps } from './props';

export const PqrHeadInfo = (props: PqrHeadInfoProps) => {
    const { formik } = usePqrHeadInfo(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Id PQR"
                    name="consecutiveFormat"
                    size="small"
                    onBlur={formik.handleBlur}
                    value={formik.values.consecutiveFormat}
                    disabled
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Id PQR SFC"
                    name="idSFC"
                    size="small"
                    onBlur={formik.handleBlur}
                    value={formik.values.idSFC}
                    disabled
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Call ID"
                    name="callId"
                    size="small"
                    onBlur={formik.handleBlur}
                    value={formik.values.callId}
                    disabled
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Detalle de PQR"
                    name="detail"
                    size="small"
                    required
                    rows={3}
                    value={formik.values.detail}
                    onChange={formik.handleChange}
                />
            </Grid>
        </Grid>
    );
};
